import React, { useEffect, useState, useContext } from "react";
import BlogPosts from "./common/blog-posts";
import Pagination from "@material-ui/lab/Pagination";
import BlogService from "../../../services/blogService";
import BlogPageProfile from "./common/blogPageProfile";
import BlogProfileNav from "./blogProfileNav";
import auth from "../../../services/authService";
import BlogMenubar from "./blogMenuBar";

import { useParams } from "react-router-dom";
import { paginate } from "../../../utils/paginate";

const UserBlog = () => {
  const [blog, setBlog] = useState([]);
  const [pageSize, setPageSize] = useState(4);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [user, setUser] = useState({});

  let { userId } = useParams();

  useEffect(() => {
    let user = auth.getCurrentUser();
    setUser(user);
    let blog = BlogService.getBlog();
    setBlog(blog);
    // let category = BlogService.getBlogCategory();
    // setCategory(category);
  }, []);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };
  const handleSearch = (query) => {
    setSearchQuery(query);
  };
  const getPageData = () => {
    const paginateBlog = paginate(blog, currentPage, pageSize);

    const pageLength = Math.ceil(blog.length / pageSize);
    return { paginateBlog, pageLength };
  };

  return (
    <div className="container-fluid">
      <div className="row rgba-white-light" style={{ height: "300px" }}>
        <img
          src="https://mdbootstrap.com/img/Photos/Slides/img%20(28).jpg"
          alt=""
          height="300"
          width="100%"
        />
      </div>

      <div className="row pt-4 px-lg-3">
        <div
          className="col-lg-4 col-sm-12 mx-auto col-md-8 px-4 pr-lg-0 pr-xl-3"
          style={{ marginTop: "-180px" }}
        >
          <BlogPageProfile></BlogPageProfile>
        </div>

        <div className="col-lg-8 col-md-12 px-4">
          <div className="row">
            <div className="col-12">
              <BlogProfileNav
                value={searchQuery}
                user={user}
                handleSearch={handleSearch}
              ></BlogProfileNav>
            </div>
          </div>
          <section className="section extra-margins pt-2">
            <hr class="red" />
            <div className="row">
              <div className="col-md-12">
                <BlogPosts
                  quantityInRow={2}
                  blog={getPageData().paginateBlog}
                ></BlogPosts>

                <Pagination
                  className="d-flex justify-content-center mb-4"
                  count={getPageData().pageLength}
                  page={currentPage}
                  onChange={handlePageChange}
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default UserBlog;
